import { ReactNode, ComponentProps, forwardRef } from "react";
import { cn } from "../../../../utils/tailwindMerger.ts";

type ContentWrapProps = ComponentProps<"div"> & {
    children: ReactNode;
    className?: string;
};

const ContentWrapper = forwardRef<HTMLDivElement, ContentWrapProps>(
    ({ children, className = "", ...rest }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    " px-2  md:!px-[2rem] mx-auto w-full max-w-7xl  overflow-hidden",
                    className,
                )}
                {...rest}
            >
                {children}
            </div>
        );
    },
);

ContentWrapper.displayName = "ContentWrapper";

export default ContentWrapper;